import {
  CANDIDATE_BATCH_RESOURCE,
  CANDIDATE_RESOURCE,
  CANDIDATE_SLOT_RESOURCE,
  EXPERIMENT_RESOURCE,
  type ExperimentDetail,
  type StudioEvent,
} from '@studio/shared';

/** Everything an open Experiment is made of, as the stream names it. */
export const EXPERIMENT_RESOURCES: readonly string[] = [
  EXPERIMENT_RESOURCE,
  CANDIDATE_BATCH_RESOURCE,
  CANDIDATE_SLOT_RESOURCE,
  CANDIDATE_RESOURCE,
];

/**
 * The version of every resource the last snapshot described. A Batch carries no
 * version of its own; its Slots do, and they are what changes.
 */
export function versionsOf(detail: ExperimentDetail): ReadonlyMap<string, number> {
  const versions = new Map<string, number>();
  versions.set(detail.experiment.id, detail.experiment.version);
  for (const batch of detail.batches) {
    for (const slot of batch.slots) versions.set(slot.id, slot.version);
  }
  for (const candidate of detail.candidates) versions.set(candidate.id, candidate.version);
  return versions;
}

/**
 * The same reconciliation the activity indicator uses, applied to an Experiment: the
 * stream is opened and buffered first, the snapshot is read, and only an event newer
 * than the snapshot is worth acting on. An event carries no payload, so acting on it
 * means reading the Experiment again - once, for anything the snapshot has not seen.
 */
export function needsRefetch(versions: ReadonlyMap<string, number>, event: StudioEvent): boolean {
  if (!EXPERIMENT_RESOURCES.includes(event.resource)) return false;
  const standing = versions.get(event.id);
  return standing === undefined || event.version > standing;
}
